import { getMethodWithToken } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Types
export const GET_CAMPAIGN_TYPE = 'GET_CAMPAIGN_TYPE';
export const GET_CAMPAIGN_TYPE_SUCCESS = 'GET_CAMPAIGN_TYPE_SUCCESS';
export const GET_CAMPAIGN_TYPE_FAILURE = 'GET_CAMPAIGN_TYPE_FAILURE';

// Action Creators
export const fetchGetCampaignType = () => ({
  type: GET_CAMPAIGN_TYPE,
});

export const fetchGetCampaignTypeSuccess = (data) => ({
  type: GET_CAMPAIGN_TYPE_SUCCESS,
  payload: data,
});

export const fetchGetCampaignTypeFailure = (error) => ({
  type: GET_CAMPAIGN_TYPE_FAILURE,
  payload: error,
});

// Thunk Function
export const getCampaignTypeCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchGetCampaignType(data, external));
    try {
      const response = await getMethodWithToken(
        url.getcampaignTypeListSuperAdmin
      );
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchGetCampaignTypeSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchGetCampaignTypeFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchGetCampaignTypeFailure(error.message));
    }
  };
};
